module.exports = __webpack_public_path__ + "static/media/swimmer.05068fb8.svg";